/**
 * Resumen corto de una descripción para correos y avisos. Los tickets de Sistemas traen
 * descripciones largas en markdown (títulos, negritas, listas): en el correo de asignación se
 * mandaba todo y el aviso se volvía una página. Aquí se quita el formato, se junta en un párrafo
 * y se corta en palabra; el detalle completo se lee en el portal.
 */
export const MAX_RESUMEN_CORREO = 280;

export function resumenTexto(texto: string | null | undefined, max = MAX_RESUMEN_CORREO): string {
  const limpio = (texto ?? "")
    .split(/\r?\n/)
    // Fuera la línea "Título: …" (ya va como nombre del ticket) y las líneas vacías.
    .filter((l) => !/^\s*[*_#>\s-]*t[ií]tulo\s*:/i.test(l))
    .map((l) =>
      l
        .replace(/^\s{0,3}(#{1,6}|>|[-*+]|\d+[.)])\s+/, "") // encabezados, citas y viñetas
        .replace(/(\*\*|__|\*|_|`|~~)/g, "") // negritas, cursivas, código
        .replace(/\[([^\]]*)\]\([^)]*\)/g, "$1") // enlaces: solo el texto
        .trim(),
    )
    .filter(Boolean)
    .join(" ")
    .replace(/\s+/g, " ")
    .trim();
  if (limpio.length <= max) return limpio;
  const corte = limpio.slice(0, max);
  const espacio = corte.lastIndexOf(" ");
  return `${(espacio > max * 0.6 ? corte.slice(0, espacio) : corte).replace(/[\s,;:.-]+$/, "")}…`;
}
